// EVENT LISTENERS
document.addEventListener('DOMContentLoaded', () => {
	Fancybox.bind('[data-fancybox]', {});
});